import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import Box from '../../../common/components/Box/Box';
import ChannelDetails from '../components/ChannelDetails';
import InternalContainer from '../../layout/containers/Internal';
import ChannelSchemes from '../components/ChannelSchemes/ChannelSchemes';
import { actions as channelActions } from '../redux/channelActions';
import getIncludedResource from '../../../helpers/getIncludedResource';
import Loader from '../../../common/components/Loader/Loader';
import { bindActionCreators } from 'redux';

class ChannelInfoView extends React.Component {
  componentWillMount() {
    const { channelActions } = this.props;
    channelActions.getChannel(this.props.params.id, [
      'organisation,broker,schemes.insurer',
    ]);
    channelActions.getAllInsurers();
    channelActions.getAllSchemes();
  }

  render() {
    const { channel, currentChannel } = this.props;
    if (!currentChannel || !currentChannel.data) {
      return <Loader />;
    }
    const allSchemes = get(channel, 'allSchemes');
    const allInsurers = get(channel, 'allInsurers');
    const channelSchemes = get(channel, 'currentChannel.included');

    const showSchemeTree = currentChannel && allInsurers && allSchemes && channelSchemes;
    const broker = getIncludedResource(
      currentChannel.data,
      currentChannel.included,
      'broker',
    );

    const title = currentChannel ? `Channel: ${currentChannel.name}` : 'Channel Details';

    return (
      <InternalContainer title={title}>
        <Box>
          <ChannelDetails channel={currentChannel.data.attributes} broker={broker} />
          <ChannelSchemes
            allSchemes={allSchemes}
            allInsurers={allInsurers}
            loading={!showSchemeTree}
            channelSchemes={channelSchemes}
            channelId={this.props.params.id}
          />
        </Box>
      </InternalContainer>
    );
  }
}

export default connect(
  (state) => {
    return {
      channel: state.channel,
      currentChannel: state.channel.currentChannel,
    };
  },
  (dispatch) => {
    return {
      channelActions: bindActionCreators(channelActions, dispatch),
    };
  },
)(ChannelInfoView);
